import { CATEGORIES_QUERY_CACHE_EXPIRE_TIME_MS } from "../../config/constansts";
import { UseQueryOptions, useQuery, useQueryClient } from "@tanstack/react-query";
import { categoriesClient } from "@core/clients";
import { Category } from "@core/types";
import { CategoriesMapObj } from "@core/types";

const useGetMainCategoriesQuery = (options: UseQueryOptions<Category[]> = {}) => {
  const queryClient = useQueryClient();

  return useQuery<Category[], any>(
    ["mainCategories"],
    async () => {
      return await categoriesClient.getMainCategories();
    },
    {
      cacheTime: CATEGORIES_QUERY_CACHE_EXPIRE_TIME_MS,
      staleTime: CATEGORIES_QUERY_CACHE_EXPIRE_TIME_MS,
      initialData: () => {
        return queryClient.getQueryData<CategoriesMapObj>(["all-categories"])?.mainCategories;
      },
      ...options,
    }
  );
};

export default useGetMainCategoriesQuery;
